<template>
   <section id="gallery" class="gallery">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2>گالری تصاویر</h2>
          <p><a href="/gallery">برای مشاهده تصاویر بیشتر کلیک کنید</a></p>
        </div>

        <div class="gallery-slider swiper">
          <div class="swiper-wrapper align-items-center">
            <div class="swiper-slide">
              <a
                class="gallery-lightbox"
                href="/assets/img/gallery/سبلان-میکسر-001.jpg"
                ><img
                  src="/assets/img/gallery/سبلان-میکسر-001.jpg"
                  class="img-fluid"
                  alt=""
              /></a>
            </div>
         
            <div class="swiper-slide">
              <a
                class="gallery-lightbox"
                href="/assets/img/gallery/سبلان-میکسر-003.jpg"
                ><img
                  src="/assets/img/gallery/سبلان-میکسر-003.jpg"
                  class="img-fluid"
                  alt=""
              /></a>
            </div>
            <div class="swiper-slide">
              <a
                class="gallery-lightbox"
                href="/assets/img/gallery/سبلان-میکسر-004.jpg"
                ><img
                  src="/assets/img/gallery/سبلان-میکسر-004.jpg"
                  class="img-fluid"
                  alt=""
              /></a>
            </div>
            <div class="swiper-slide">
              <a
                class="gallery-lightbox"
                href="/assets/img/gallery/سبلان-میکسر-005.jpg"
                ><img
                  src="/assets/img/gallery/سبلان-میکسر-005.jpg"
                  class="img-fluid"
                  alt=""
              /></a>
            </div>

              <div class="swiper-slide">
              <a
                class="gallery-lightbox"
                href="/assets/img/gallery/سبلان-میکسر-006.jpg"
                ><img
                  src="/assets/img/gallery/سبلان-میکسر-006.jpg"
                  class="img-fluid"
                  alt=""
              /></a>
            </div>

           
              <div class="swiper-slide">
              <a
                class="gallery-lightbox"
                href="/assets/img/gallery/سبلان-میکسر-008.jpg"
                ><img
                  src="/assets/img/gallery/سبلان-میکسر-008.jpg"
                  class="img-fluid"
                  alt=""
              /></a>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
 
}
</script>

<style>

</style>